export const DEFAULT_LOCALE = 'vi-VN'
export const DEFAULT_CURRENCY = 'VND'